<template>
    <div v-if="!loading">
        <b-row>
            <b-col md="3" class="mb-2">
                <b-form-input v-model="parameters.phoneNumber" placeholder="شماره همراه مدیر" class="text-center"
                    dir="ltr" />
            </b-col>
            <b-col md="3" class="mb-2">
                <b-form-input v-model="parameters.transactionCode" placeholder="شماره تراکنش بانک" class="text-center"
                    dir="ltr" />
            </b-col>
            <b-col md="2" class="mb-2">
                <b-form-input v-model="parameters.trackingNumber" placeholder="شماره پیگیری" class="text-center"
                    dir="ltr" />
            </b-col>
            <b-col md="2" class="mb-2">
                <v-select v-model="parameters.subscriptionId" dir="rtl" placeholder="نوع اشتراک"
                    :options="subscriptionIdData" :reduce="(value) => value.id" class="bg-white"
                    style="border-radius: 8px;" label="name" :clearable="false">
                    <template #no-options>
                        موردی وجود ندارد
                    </template>
                </v-select>
            </b-col>
            <b-col md="2" class="mb-2">
                <b-button @click="getStoreSubscriptions" variant="primary" class="w-100">اعمال فیلتر</b-button>
            </b-col>
        </b-row>


        <b-card class="p-0" no-body>
            <b-overlay :show="loadingPage" variant="transparent" opacity="1" blur="3px" rounded="sm">
                <b-table responsive :items="storeSubscriptionsList" :fields="fields" class="mb-0">
                    <template #cell(createdAt)="data">
                        <div>
                            <span>
                                {{ new Date(data.item.createdAt).toLocaleDateString('fa-IR') }}
                            </span>
                            <span> - </span>
                            <span>
                                {{ new Date(data.item.createdAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                    2).join(":") }}
                            </span>
                        </div>
                    </template>
                    <template #cell(price)="data">
                        {{ data.item.price == 0 ? 'رایگان' : data.item.price.toLocaleString('fa-IR') }}
                    </template>
                    <template #cell(isUpgrade)="data">
                        {{ data.item.isUpgrade ? 'ارتقاء' : 'تمدید' }}
                    </template>
                    <template #cell(status)="data">
                        {{ storeSubscriptionStatus(data.item.status) }}
                    </template>
                    <template #cell(trackingNumber)="data">
                        {{ data.item.trackingNumber == 0 ? '-' : data.item.trackingNumber }}
                    </template>
                    <template #cell(store.name_Fa)="data">
                        <div v-if="data.item.store">{{ data.item.store.name_Fa ? data.item.store.name_Fa : '-' }}</div>
                    </template>
                    <template #cell(startedAt)="data">
                        {{ data.item.startedAt ? new Date(data.item.startedAt).toLocaleDateString('fa-IR') : '-' }}
                    </template>
                    <template #cell(bankTransactionCode)="data">
                        {{ data.item.bankTransactionCode ? data.item.bankTransactionCode : '-' }}
                    </template>
                    <template #cell(expiredAt)="data">
                        {{ data.item.expiredAt ? new Date(data.item.expiredAt).toLocaleDateString('fa-IR') : '-' }}
                    </template>
                    <template #cell(totalDays)="data">
                        {{ data.item.totalDays }} روز
                    </template>
                </b-table>
            </b-overlay>
        </b-card>
        <b-pagination align="center" @input="getStoreSubscriptions" v-model="parameters.pageIndex"
            :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />
    </div>
</template>

<script>
import { BCard, BCardText, BLink, BRow, BCol, BButton, BImg, BAvatar, BTable, BPagination, BOverlay, BFormInput } from 'bootstrap-vue';
import { adminService } from '@core/services';
import vSelect from 'vue-select';

export default {
    components: {
        BCard,
        BCardText,
        BLink,
        BRow,
        BCol,
        BButton,
        BImg,
        BAvatar,
        BTable,
        BPagination,
        BFormInput,
        BOverlay,
        vSelect
    },
    data() {
        return {
            loading: true,
            loadingPage: false,
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                subscriptionId: null,
                trackingNumber: null,
                transactionCode: null,
                phoneNumber: null,
                totalCount: null,
            },
            subscriptionIdData: [
                { name: 'پایه', id: 1 },
                { name: 'پیشرفته', id: 2 },
                { name: 'رویال', id: 3 },
            ],
            fields: [
                {
                    key: 'trackingNumber',
                    label: 'شماره پیگیری',
                },
                {
                    key: 'store.name_Fa',
                    label: 'نام مجموعه',
                },
                {
                    key: 'admin.phoneNumber',
                    label: 'شماره همراه مدیر',
                },
                {
                    key: 'createdAt',
                    label: 'تاریخ',
                },
                {
                    key: 'price',
                    label: 'مبلغ (ریال)',
                },
                {
                    key: 'subscriptionTitle',
                    label: 'نام اشتراک',
                },
                {
                    key: 'isUpgrade',
                    label: 'نوع',
                },
                {
                    key: 'totalDays',
                    label: 'تعداد روز ها',
                },
                {
                    key: 'status',
                    label: 'وضعیت',
                },
                {
                    key: 'bankTransactionCode',
                    label: 'شماره تراکنش بانک',
                },
                {
                    key: 'startedAt',
                    label: 'شروع',
                },
                {
                    key: 'expiredAt',
                    label: 'پایان',
                },
            ],
            storeSubscriptionsList: []
        }
    },
    computed: {
        storeSubscriptionStatus() {
            return (status) => {
                if (status == 0) {
                    return 'پرداخت نشده'
                }
                if (status == 1) {
                    return 'پرداخت ناموفق'
                }
                if (status == 2) {
                    return 'رزرو شده'
                }
                if (status == 3) {
                    return 'فعال'
                }
                if (status == 4) {
                    return 'منقضی شده'
                }
            }
        },
    },
    methods: {
        getStoreSubscriptions() {
            this.loadingPage = true
            adminService.storeSubscriptions(this.parameters).then(({ data }) => {
                this.parameters.totalCount = data.totalCount
                this.storeSubscriptionsList = data.items
                this.loadingPage = false
                this.loading = false
            })
        },
    },
    mounted() {
        this.getStoreSubscriptions()
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>